import ActionTypes from "./ActionTypes";

const get_cus_modules = (payload) => {
  return {
    type: ActionTypes.GET_CUS_MODULES,
    payload: payload,
  };
};

const get_cus_module_detail = (payload) => {
  return {
    type: ActionTypes.GET_CUS_MODULE_DETAILS,
    payload: payload,
  };
};

export {get_cus_modules, get_cus_module_detail}